module.exports = __webpack_public_path__ + "static/media/notificacoes.70dfda2d.png";